<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="85" height="95" viewBox="0 0 85 95">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M31.392 1.39c-22.5 5.9-35.902 28.899-30 51.399 2.801 10.602 9.399 19.3 18 24.699l-11 16.898 44.398-11.7c22.5-5.898 35.902-28.897 30-51.296-5.898-22.5-28.898-35.897-51.398-30zm5.5 56.798L21.693 42.89l5.602-5.602 9.601 9.602 20-20 5.602 5.601-25.606 25.696z"
    />
  </svg>
</template>
